import dayjs from 'dayjs';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { defaultLocale } from 'src/locales';

export const localeStorageKey = 'preferredLocale';
export const themeStorageKey = 'preferredTheme';
export const displayTenantSwitcherAfterLogin = 'displayTenantSwitcherAfterLogin';

export const isNavigationMenuOpenState = atom<boolean>(false);

export const isNavigationMenuCollapsedState = atomWithStorage<boolean>('isNavigationMenuCollapsed', false);

export const isSettingsMenuOpenState = atom<boolean>(false);

const baseLocaleState = atomWithStorage<string>(localeStorageKey, defaultLocale.code);

export const currentLocaleState = atom(
  (get) => get(baseLocaleState),
  (_get, set, nextLocale: string) => {
    set(baseLocaleState, nextLocale);
    dayjs.locale(nextLocale);
  }
);


currentLocaleState.onMount = (setAtom: (val: string) => void) => {
  let initial = defaultLocale.code;
  try {
    const stored = localStorage.getItem(localeStorageKey);
    if (stored != null) {
      initial = JSON.parse(stored);
    } else {
      const userLanguage = navigator.language;
      initial = userLanguage.startsWith('fr') ? 'fr-CA' : 'en-CA';
    }
  } catch {
    // ignore storage parsing errors
  }
  dayjs.locale(initial);
  setAtom(initial);
};

export const currentThemeNameState = atomWithStorage<string>(themeStorageKey, 'light');

export const displayTenantSwitcherAfterLoginState = atomWithStorage<boolean>(displayTenantSwitcherAfterLogin, false);